export enum MeasureUnit {
    Metric = 0,
    Imperial = 1
}
